function isIncludesCountry(countries, countryCode) {
  return countries.includes(countryCode)
}

export { isIncludesCountry }
